export const DATE_FORMAT_ISO = 'YYYY-MM-DD';
export const DATE_FORMAT_WEB = 'DD-MM-YYYY';
export const DATE_NO_DAY_FORMAT_WEB = 'MM-YYYY';
export const TIME_FORMAT = 'HH:mm:ss';
export const DATETIME_FORMAT_ISO = 'YYYY-MM-DDTHH:mm:ss';
export const DATETIME_FORMAT_WEB = 'DD-MM-YYYY HH:mm:ss';
export const DATETIME_FORMAT_WEB_SLASH = 'DD/MM/YYYY HH:mm:ss';
export const DATE_FORMAT_WEB_SLASH = 'DD/MM/YYYY HH:mm:ss';
export const DATETIME_FORMAT_ISO_MILISECONDS = 'YYYY-MM-DDTHH:mm:ss.SSSZ';
